import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "contexts";
import { StyledContainer } from "customStyled";

const VerifyCompleteRoutes = () => {
  const { isVerify } = useAuthContext();

  if (!isVerify) {
    return <Navigate to="/" replace />;
  }
  return (
    <StyledContainer direction="column" sx={{ justifyContent: "space-between" }}>
      <Outlet />
    </StyledContainer>
  );
};

export default VerifyCompleteRoutes;
